import { render, staticRenderFns } from "./BitcoinOffer.vue?vue&type=template&id=287b48d5&scoped=true&"
import script from "./BitcoinOffer.vue?vue&type=script&lang=js&"
export * from "./BitcoinOffer.vue?vue&type=script&lang=js&"
import style0 from "./BitcoinOffer.vue?vue&type=style&index=0&id=287b48d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b48d5",
  null
  
)

export default component.exports